export default {
  name: 'Mobilleo',
  slug: 'mobilleo',
  title: 'Mobilleo',
  email: 'res@mobilleo.com',
  brandingLogo: 'mobilleo-logo.svg',
  brandingIcon: '',
  token: JSON.parse(process.env.VUE_APP_SWITCH_URLS)['mobilleo'],
  hex: '#4361EE',
  hasTravelType: true,
  hasReasonFor: true,
  spinnerType: 'geo',
  appLinks: null,
  termsURL: 'https://www.mobilleo.com/legal/terms',
  privacyURL: 'https://www.mobilleo.com/legal/privacy-policy',
  pages: {
    login: {
      form: {
        class: 'row text-black',
        welcomeMessage: {
          class: 'col-12 text-h6 text-center text-weight-bold q-mt-md q-mb-xl',
          text: 'Hello again! Please sign in'
        },
        email: {
          dark: false,
          color: 'black',
          filled: false,
          square: false,
          outlined: true,
          class: 'col-12'
        },
        password: {
          dark: false,
          color: 'black',
          filled: false,
          square: false,
          outlined: true,
          class: 'col-12'
        },
        signIn: {
          class: 'full-width q-my-md',
          color: 'primary',
          size: 'lg'
        },
        skipLogin: {
          class: 'skipLogin full-width q-mb-md',
          color: 'black',
          size: 'md'
        },
        forgotPassword: {
          class: 'q-my-md text-primary text-bold',
          style: 'margin-left: auto;'
        },
        validation: {
          class: 'space row col text-center text-negative strong'
        },
        createButton: {
          class: 'full-width q-my-md',
          color: 'primary',
          size: 'lg'
        },
        completeButton: {},
        verificationButton: {
          class: 'q-my-md mr-auto',
          color: 'primary',
          align: 'center'
        }
      }
    },
    password: {
      email: {
        form: {
          class: 'request-reset text-black',
          welcomeMessage: {
            class: 'text-h6 text-center text-weight-bold q-mt-md q-mb-xl'
          },
          email: {
            dark: false,
            color: 'black',
            filled: false,
            square: false,
            outlined: true
          },
          resetButton: {
            class: 'full-width q-my-md',
            color: 'primary'
          },
          backButton: {
            class: 'full-width q-my-md text-primary',
            unelevated: true,
            flat: true
          }
        }
      },
      reset: {
        form: {
          class: 'text-black',
          welcomeMessage: {},
          email: {
            dark: false,
            color: 'black',
            filled: false,
            square: false,
            outlined: true
          },
          password: {
            dark: false,
            color: 'black',
            filled: false,
            square: false,
            outlined: true
          },
          passwordConfirmation: {
            dark: false,
            color: 'black',
            filled: false,
            square: false,
            outlined: true
          },
          resetButton: {
            class: 'full-width q-my-md',
            color: 'primary',
            size: 'lg',
            align: 'center'
          }
        }
      }
    },
    signup: {
      complete: {
        form: {
          class: 'row text-black',
          welcomeMessage: {
            class: 'col-12 text-h6 text-center text-weight-bold q-mt-md q-mb-xl'
          },
          email: {
            dark: false,
            color: 'black',
            filled: false,
            square: false,
            outlined: true,
            class: 'full-width'
          },
          organisationName: {
            dark: false,
            color: 'black',
            filled: false,
            square: false,
            outlined: true,
            class: 'full-width'
          },
          name: {
            dark: false,
            color: 'black',
            filled: false,
            square: false,
            outlined: true,
            class: 'full-width'
          },
          password: {
            dark: false,
            color: 'black',
            filled: false,
            square: false,
            outlined: true,
            class: 'full-width'
          },
          passwordConfirmation: {
            dark: false,
            color: 'black',
            filled: false,
            square: false,
            outlined: true,
            class: 'full-width'
          },
          completeButton: {
            class: 'full-width',
            size: 'lg',
            color: 'primary'
          },
          skipLogin: {
            class: 'skipLogin full-width q-my-md',
            color: 'black',
            size: 'md'
          }
        }
      }
    },
    verification: {
      submitButton: {
        class: ''
      }
    }
  },
  components: {
    mGmaps: {
      markers: []
    },
    mImageModal: {
      spinnerType: 'geo',
      spinnerClass: 'loader'
    },
    mMobilityNearbyList: {
      spinnerType: 'geo',
      spinnerClass: 'loader'
    },
    mMobileAppbar: {
      toolbarTitle: {
        img: {}
      }
    }
  },
  contents: {
    driving: { showInSmartSearch: true },
    bicycle: { showInSmartSearch: true },
    walking: { showInSmartSearch: true },
    bus: { showInSmartSearch: true },
    tram: { showInSmartSearch: true },
    subway: { showInSmartSearch: true },
    rail: { showInSmartSearch: true },
    bikehire: { showInSmartSearch: true },
    carclub: { showInSmartSearch: true },
    rental: { showInSmartSearch: true },
    ridehailing: { showInSmartSearch: true },
    flight: { showInSmartSearch: true },
    hotel: { showInSmartSearch: true }
  },
  mobility: [
    'tube'
  ],
  bookables: [
    'onwardtravel',
    'bus',
    'tram',
    'train',
    'bikehire',
    'carclub',
    'ridehailing',
    'rental',
    'flight',
    'hotel'
  ],
  nearby: [
    'parking',
    'gas_station',
    'ev_station',
    'atm',
    'car_wash',
    'car_repair',
    'restaurant',
    'bar',
    'cafe'
  ]
}
